import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { rollbackVersions } from '@api/v4/attachments/versions';
import UploadArea from '@components/common/filestack_uploader/upload_area';
import TimelineEvent from './timeline_event';

import './styles/main.scss';

const Versions = ({
  activeAttachment,
  asset,
  initializeSidebar,
  setActiveTab,
  setActiveVersion,
  updateFetchControllers,
  users,
  versionCards,
}) => {
  const [isVersionUploading, setIsVersionUploading] = useState(false);
  const [isVersionUpdating, setIsVersionUpdating] = useState(false);

  const makeCurrentVersion = (versionKey) => {
    setIsVersionUpdating(true);
    rollbackVersions({ versionKey }, updateFetchControllers)
      .then((response) => {
        setIsVersionUpdating(false);
        if (response.data) {
          initializeSidebar();
        }
      });
  };

  const currentVersionIndex = versionCards.findIndex((card) => card.type === 'version');
  const quantityVersions = versionCards.filter((card) => card.type === 'version').length;
  const uploadOptions = {
    maxFiles: 1,
    onFileUploadStarted: () => setIsVersionUploading(true),
  };

  return (
    <div className="versions-container bf-scroll-element">
      <div className="timeline-header-container">
        <div className="header-copy">
          <h4>
            {quantityVersions === 1
              ? t('1 previous version of')
              : `${quantityVersions} ${t('previous versions of')}`
            }
            <span className="filename">
              {versionCards[currentVersionIndex].version_details.filename}
            </span>
          </h4>
        </div>
        {!BFG.hasFeature('uppy_uploader_features') && (
          <UploadArea
            asset={asset}
            assetKey={asset.asset_key}
            attachment={activeAttachment}
            options={uploadOptions}
            uniqDomElement={`version-status-uploader-${activeAttachment.id}`}
            updateTab={initializeSidebar}
            uploadType="attachment-version-status"
          />
        )}
      </div>
      <div className="timeline-events">
        {versionCards.map((event, i) => (
          <TimelineEvent
            isCurrentVersion={i === currentVersionIndex}
            isVersionUpdating={isVersionUpdating}
            key={event.created_at}
            makeCurrentVersion={makeCurrentVersion}
            setActiveTab={setActiveTab}
            setActiveVersion={setActiveVersion}
            users={users}
            version={event}
            versionUploading={isVersionUploading}
          />
        ))}
      </div>
    </div>
  );
};

export default Versions;

Versions.propTypes = {
  activeAttachment: PropTypes.shape({
    id: PropTypes.string
  }).isRequired,
  asset: PropTypes.shape({
    asset_key: PropTypes.string
  }).isRequired,
  initializeSidebar: PropTypes.func.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  setActiveVersion: PropTypes.func.isRequired,
  updateFetchControllers: PropTypes.func.isRequired,
  users: PropTypes.shape({}).isRequired,
  versionCards: PropTypes.arrayOf(PropTypes.shape({
    version_details: PropTypes.shape({
      filename: PropTypes.string,
    })
  })).isRequired,
};
